import OrderRow from '../OrderRow';

import NoOrders from './NoOrders';

const OrderList = (props) => {
  const { orders, query, settings } = props;

  if (query.length === 0) {
    return <NoOrders />;
  }
  return (
    <>
      {query.map((orderId) => (
        <OrderRow key={orderId} order={orders[orderId]} settings={settings} />
      ))}
    </>
  );
};

export default OrderList;
